const modal = (function() {
    const modalContainer = document.createElement('div');
    modalContainer.className = 'modal-container';
    modalContainer.innerHTML = `
        <div class="modal-overlay"></div>
        <div class="modal-content">
            <div class="modal-icon"></div>
            <h3 class="modal-title"></h3>
            <p class="modal-message"></p>
            <button class="modal-close">OK</button>
        </div>
    `;

    document.body.appendChild(modalContainer);

    const overlay = modalContainer.querySelector('.modal-overlay');
    const content = modalContainer.querySelector('.modal-content');
    const icon = modalContainer.querySelector('.modal-icon');
    const title = modalContainer.querySelector('.modal-title');
    const message = modalContainer.querySelector('.modal-message');
    const closeBtn = modalContainer.querySelector('.modal-close');

    function show(type, msg) {
        modalContainer.classList.remove('hidden');
        
        if (type === 'success') {
            icon.className = 'modal-icon success';
            icon.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="20 6 9 17 4 12"></polyline></svg>';
            title.textContent = 'Success';
            title.className = 'modal-title success';
        } else if (type === 'error') {
            icon.className = 'modal-icon error';
            icon.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"></circle><line x1="15" y1="9" x2="9" y2="15"></line><line x1="9" y1="9" x2="15" y2="15"></line></svg>';
            title.textContent = 'Error';
            title.className = 'modal-title error';
        } else {
            icon.className = 'modal-icon info';
            icon.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="16" x2="12" y2="12"></line><line x1="12" y1="8" x2="12.01" y2="8"></line></svg>';
            title.textContent = 'Info';
            title.className = 'modal-title info';
        }
        
        message.textContent = msg;
        
        setTimeout(() => {
            modalContainer.classList.add('show');
        }, 10);
    }

    function hide() {
        modalContainer.classList.remove('show');
        setTimeout(() => {
            modalContainer.classList.add('hidden');
        }, 300);
    }

    function showSuccess(msg) {
        show('success', msg);
        setTimeout(hide, 2000);
    }

    function showError(msg) {
        show('error', msg);
    }

    function showInfo(msg) {
        show('info', msg);
    }

    closeBtn.addEventListener('click', hide);
    overlay.addEventListener('click', hide);

    return {
        show,
        hide,
        showSuccess,
        showError,
        showInfo
    };
})();